var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":"ltr"}},[_c('slick',{ref:"slick",staticClass:"sponsers-slick",attrs:{"options":_vm.slickOptions}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }